<epay-page-content [pagetitle]="pagetitle">
  <div class="page-content-main box-panel shadow t-alignC max-w max-gs" id="page-content-main">
    <h2 class="mb-5">Select New Account Type</h2>
    <div class="account-type-links">
      <a class="btn-link mx-3 mb-3" [routerLink]="['/ncp/register']">Noncustodial Parent</a>
      <a class="btn-link mx-3 mb-3" [routerLink]="['/employer/register']">Employer</a>
    </div>
  </div>
</epay-page-content>
